<template>
  <v-col>
    <!-- sales data table -->
    <refunds-table
      :key="index"
      url-api="/products"
      :headers="headers"
    >
      <!-- New Product -->
      <template #urlCreate>
        <v-btn
          class="info"
          @click.prevent="
            $router.push({
              name: 'AddNewProduct',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          New Product
        </v-btn>
      </template>
      <!-- end -->
      <!-- Product logo uploading -->
      <template #image="{ item }">
        <v-edit-dialog>
          <v-img
            :src="'/storage/' + item.image"
            lazy-src="/storage/default_img/no_image.png"
            aspect-ratio="1"
            max-width="50"
            max-height="50"
          />
          <template #input>
            <v-file-input
              v-model="product.image"
              label="Select File"
              placeholder="Upload Image"
              accept="image/jpg, image/png, image/jpeg"
              @change="uploadProductImage(item)"
            />
          </template>
        </v-edit-dialog>
      </template>
      <!-- end -->

      <!-- Discount state toggle -->
      <template #discounted="{ item }">
        <v-edit-dialog>
          {{ item.discounted ? "Yes" : "No" }}

          <template #input>
            <v-select
              v-model="item.discounted"
              :items="toggleStates"
              item-text="title"
              item-value="value"
              label="Change Discount Status"
              cols="3"
              placeholder="Discount status"
              @change="toggleDiscountState(item)"
            />
          </template>
        </v-edit-dialog>
      </template>
      <!-- end -->

      <!-- Sale Status toggle -->
      <template #state="{ item }">
        <v-edit-dialog>
          <template v-if="item.state">
            <span class="success--text">Active</span>
          </template>
          <template v-else>
            <span class="error--text">Inactive</span>
          </template>
          <template #input>
            <v-select
              v-model="item.state"
              :items="toggleStates"
              item-text="title"
              item-value="value"
              label="Switch product sale state"
              cols="3"
              placeholder="Product status"
              @change="toggleProductState(item)"
            />
          </template>
        </v-edit-dialog>
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template #columnaction="{ item }">
        <!-- Product edit -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'EditProduct',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Product Edit</span>
        </v-tooltip>
        <!-- end -->

        <!-- Lable Print -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'ProductLabel',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-barcode
              </v-icon>
            </v-btn>
          </template>
          <span>Print Product Lable</span>
        </v-tooltip>
        <!-- end -->

        <!-- Product details -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'ProductDetail',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-more
              </v-icon>
            </v-btn>
          </template>
          <span>Product Details</span>
        </v-tooltip>
        <!-- end -->

        <!-- Product remove -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="error--text"
              small
              icon
              @click="warningProductRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </refunds-table>

    <!-- end data table -->

    <!-- Product remove warning -->
    <v-dialog
      v-model="productRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="productRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeProduct"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import SaleReturnsTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "refunds-table": SaleReturnsTable,
  },
  data() {
    return {
      product: [],
      productRemoveWarning: false,
      refund: [],
      index: 1,
      toggleStates: [
        { title: "Yes", value: 1 },
        { title: "No", value: 0 },
      ],
      headers: [
        {
          text: "Type",
          sortable: true,
          value: "type",
        },
        {
          text: "Image",
          sortable: false,
          value: "image",
          slot: "image",
        },
        {
          text: "Added At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Product Name",
          sortable: true,
          value: "name",
        },
        {
          text: "SKU",
          align: "start",
          sortable: false,
          value: "sku",
        },
        {
          text: "UPC",
          sortable: false,
          value: "barcode",
        },

        {
          text: "Discounted",
          sortable: true,
          value: "discounted",
          slot: "discounted",
        },

        {
          text: "State",
          sortable: true,
          value: "state",
          slot: "state",
        },
        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    toggleProductState(product) {
      window.axios
        .post("/toggle-product-sale-state/" + product.id, product)
        .then((response) => {
          this.feedback(response.data.message);
        });
    },

    toggleDiscountState(product) {
      window.axios
        .post("/toggle-product-discount/" + product.id, product)
        .then((response) => {
          this.feedback(response.data.message);
        });
    },

    uploadProductImage(item) {
      if (this.product.image !== null) {
        let formData = new FormData();
        formData.append("image", this.product.image, this.product.image.name);
        window.axios
          .post(`/product-image/${item.id}`, formData)
          .then((response) => {
            this.$data.index++;
            this.product.image = null;
            this.feedback(response.data.message);
          });
      }
    },

    removeProduct() {
      window.axios
        .delete("/product/" + this.$data.product.id)
        .then((response) => {
          this.feedback(response.data.message);
          this.productRemoveWarning = false;
          this.$data.index++;
        });
    },

    warningProductRemove(product) {
      this.product = product;
      this.productRemoveWarning = true;
    },
  },
};
</script>
